<template>
        <div class="left_block">
            <drag-and-drop @fileDropped="filePrepare">
                <fieldset class="left_block__fieldset fieldset_params">
                    <legend>Параметры</legend>
                    <ValidationObserver ref="leftBlock">
                            <div class="params">
            <!--                    <div class="params__element">-->
            <!--                        <label> Начать с</label>-->
            <!--                        <input min="0" type="number" style="width: 54px;"-->
            <!--                            :value="params.parseFromRow" @input="setParseFromRow($event.target.value)">-->
            <!--                    </div>-->
            <!--                    <div class="params__element">-->
            <!--                        <label>Отображать по</label>-->
            <!--                        <input min="0" type="number" style="width: 91px;" disabled :value="params.showLimit" @input="setShowLimit($event.target.value)">-->
            <!--                    </div>-->
            <!--                    <div class="params__element">-->
            <!--                        <label>Всего строк</label>-->
            <!--                        <input disabled type="number" title="Номер последней строки" style="width: 74px;" v-model="leftTableData.total">-->
            <!--                    </div>-->
                                <div class="params__element">
                                    <label>
                                        Название категорий&nbsp;<i class="far fa-question-circle" aria-hidden="true"
                                                                   v-tooltip="{content: 'Если в загруженном файле категория услуги является отдельной колонкой,' +
                                             ' то должен быть выбран тип «Cтолбец» и в шапке таблицы указать какой столбец. Если категория это объединение ячеек, то нужно выбрать тип' +
                                             '«Совмещенный» и указать какой именно диапазон является категорией; после выбора диапазона, категории подсветятся зеленым,' +
                                              'если категория отсутствует, то выбрать «Без категории»'}"/></label>
                                    <v-select style="width: 190px;" :value="params.categoryType"
                                        @input="setCategoryType" :options="categoryTypeList"/>
                                </div>
                                <div class="params__element" v-if="params.categoryType === 'merge'">
                                    <label>Объединение</label>
                                    <v-select style="width: 86px;" :value="params.mergeCellsRange"
                                        @input="setCellsRange" :options="mergeCellsRangeList"/>
                                </div>
                                <div class="params__element element_errors">
                                    <span class="element_errors__critical" v-if="Object.values(this.info.errors).length > 0">
                                        <i class="fas fa-triangle-exclamation"/>Ошибок: {{errorsSum}}
                                        <i class=" fa-xs far fa-question-circle i_info_help" aria-hidden="true"
                                            v-tooltip="{content: infoTooltip(info.errors_info)}"/>
                                    </span>
                                    <span class="element_errors__warnings" v-if="Object.values(this.info.warnings).length > 0">
                                        <i class="fas fa-siren"/>Предупр.: {{warningsSum}}
                                        <i class=" fa-xs far fa-question-circle i_info_help" aria-hidden="true"
                                            v-tooltip="{content: infoTooltip(info.warnings_info)}"/>
                                    </span>
                                </div>
                                <div class="params__element fl-r" style="padding-top: 18px;" v-if="$can('admin.pricelists.doctu.update')">
                                    <button class="small" @click.prevent="showFileChooser()">   <i class="far fa-folder-open" aria-hidden="true"/> Загрузить файл</button>
                                    <input type="file" style="display: none" :accept="allowedTypes.join(',')" ref="uploadInput" @input="fileChoose" />
                                </div>
                            </div>
                    </ValidationObserver>
                </fieldset>
            </drag-and-drop>
            <fieldset class="left_block__fieldset fieldset_orig_table">
                <legend>Оригинал</legend>
                <div class="div__table_left">
                    <table ref="leftTable" class="table_left" :class="{loading: loading}">
                        <tr class="table_left__tr_head_first">
                            <th title="Номер строки исходного файла">№ стр</th>
                            <th v-for="item in leftTableData.columns" align="center">
                                {{ item }}
                            </th>
                        </tr>
                        <tr>
                            <th><input :value="params.showFromRow" @input="setShowFromRow($event.target.value)"></th>
                            <th v-for="item in leftTableData.columns">
                                <v-select
                                    :id="item"
                                    v-model="aliases[item]"
                                    @select="checkSelectors"
                                    :options='[{
                                        value: null,
                                        text: "\u00a0"
                                   },...computedHeadersList]'>
                                </v-select>
                            </th>
                        </tr>
                        <tr v-for="(row, key) in paginatedRows" :class="[getRowErrorClass(key),getPricelessCatRow(row),{lastRow: key == leftTableData.total }]"
                            v-tooltip="{    content: rowErrorTooltip(key), template: $errTemplate }">
                            <td><div class="table_left__cell_default">{{ key }}</div></td>
                            <td v-for="(cell, columnIndex) in row" :colspan="calculateMergeLength(cell.mergeInfo)"
                                v-tooltip.right-start="{    content: cell.data !== null && cell.data.length > 16 ? cell.data : '',      delay: 550 }"
                                :class="{table_left__td_cat_merge: cell.mergeInfo !== false, table_left__td_cat: isMergedCategory(cell.mergeInfo)}">
                                <div class="table_left__cell_default">{{ cell.data }}</div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div style="float: right;padding-right: 15px;">
                    <button class="tiny" :disabled="currentPage<=1"
                        @click="currentPage--"><i class="fa fa-arrow-left"></i> пред
                    </button>
                    <span v-for="row in paginationNumbers">
                        <button class="tiny" @click="currentPage=row.value"
                            :class="{'black': row.text == currentPage}"
                            v-if="row.text != '...'">{{ row.text }}</button>
                        <select class="tiny button"  style="width:21px;height:18px" @change="goPage(currentPage)" v-model="currentPage"
                            :class="{'blue': row.text == currentPage}" v-if="row.text == '...'">
                            <option disabled value="">.......</option>
                            <option v-for="row in row.value" :value="row.value">{{ row.text }}</option>
                        </select>
                    </span>
                    <button class="tiny" :disabled="currentPage>=totalPages"
                        @click="currentPage++">след <i class="fa fa-arrow-right"></i></button>
                </div>
            </fieldset>
        </div>
</template>
<script>
import dragAndDrop from '@base/DragAndDrop.vue';
import StepOneTwoMixin from "@dialogs/pricelists/StepOneTwoMixin";
import Vue from 'vue';
import { mapState, mapMutations, mapActions } from "vuex";
export default {
    mixins:[StepOneTwoMixin],
    components: {
        dragAndDrop
    },
    data: function () {
        return {
            aliases: {},
            pagesmax: 11,
            loading: false,
            request: null,
            mergeCellsRangeList: [],
            categoryTypeList: [
                {text: 'Без категорий', value: 'absent'},
                {text: 'В выбранном столбце', value: 'column'},
                {text: 'Из объединенных ячеек', value: 'merge'},
                {text: 'Из строк без цены', value: 'priceless'},
            ],
            headersList: [
                {text: 'Наименование', value: 'name'},
                {text: 'Код', value: 'code'},
                {text: 'Цена', value: 'price'},
                {text: 'Категория', value: 'category'},
                {text: 'Подкатегория 1', value: 'subcategory1'},
                {text: 'Подкатегория 2', value: 'subcategory2'},
                {text: 'Описание', value: 'description'},
            ],
            leftTableData: {
                mergeList: [],
                total: 0,
                columns: [],
                rows: [],
            },
            currentPage: 1
        };
    },
    methods: {
        ...mapMutations({
            setVisible: 'stepTwo/setVisible',
            setParseFromRow: 'stepTwo/setParseFromRow',
            setShowFromRow: 'stepTwo/setShowFromRow',
            setCalcAlias: 'stepTwo/setCalcAlias',
            setAliases: 'stepTwo/setAliases',
            setShowLimit: 'stepTwo/setShowLimit',
            setCellsRange: 'stepTwo/setCellsRange',
            setCategoryType: 'stepTwo/setCategoryType',
        }),
        ...mapActions({
            resetData: 'stepTwo/resetState'
        }),
        checkSelectors(selectedOption, id) {
            Object.keys(this.params.aliases).forEach((column) => {
                if (column !== id && this.params.aliases[column] === selectedOption.value) {
                    this.aliases[column] = null;
                }
            });
        },
        refreshLeftTable() {
            this.loading = true;
            if (this.request) {
                this.request.cancel();
            }
            this.request = this.axios.CancelToken.source();

            let requestPromise = this.axios.post('doctu/spreadsheetToArray/' + this.priceListFileId,
                {'params': this.params}, {cancelToken: this.request.token})
            requestPromise.then((response) => {
                    Vue.set(this, 'leftTableData', response.data)

                    if (this.params.calcAlias) {
                        let preparedSelectors = this.prepareSelectors(response.data);
                        Vue.set(this, 'aliases', preparedSelectors);
                    }
                    this.setVisible();
                    this.loading = false
                    this.setCalcAlias(false);
                    this.updateMergeCellList()
                },
                () => {
                });
            return requestPromise;
        },
        updateMergeCellList() {
            this.leftTableData.mergeList.forEach((mergeRange) => {
                if (this.mergeCellsRangeList.find(item => item.value === mergeRange) === undefined) {
                    this.mergeCellsRangeList.push({value: mergeRange, text: mergeRange})
                }
            })
        },
        isMergedCategory(mergeInfo) {
            if (this.params.categoryType !== 'merge' || mergeInfo === false) {
                return false;
            }
            return this.params.mergeCellsRange === mergeInfo.replace(/\d/g, '');
        },
        calculateMergeLength(range) {
            if (range === false) {
                return 1;
            }

            return range.charCodeAt(range.indexOf(':') + 1) - range.charCodeAt(0) + 1 - this.countMissing(range);
        },
        countMissing(range) {
            let startIndex = range.charCodeAt(0);
            let endIndex = range.charCodeAt(range.indexOf(':') + 1)
            let counter = 0;
            while (startIndex <= endIndex) {
                let containsCell = false;
                this.leftTableData.columns.forEach((columnIndex) => {
                    if (columnIndex.charCodeAt(0) === startIndex){
                        containsCell = true;
                    }
                })
                if (!containsCell){
                    counter++;
                }
                startIndex++;
            }
        return counter;
        },
        prepareSelectors(data) {
            let res = {}
            data.columns.forEach(columnIndex => {
                let match = data.alias.find(function (e) {
                    return Object.values(e).indexOf(columnIndex) > -1
                })
                res[columnIndex] = match === undefined ? null : Object.keys(match).shift();
            });
            return res
        },
        getBordersClass(columnIndex, mergeInfo) {
            let resStyleClass = 'hor-border'
            if (mergeInfo === false) {
                return resStyleClass + ' r-border l-border'
            }
            resStyleClass += ' table_left__td_cat_merge';
            if (columnIndex === mergeInfo[0]) {
                return resStyleClass + ' l-border'
            }
            if (columnIndex === mergeInfo[mergeInfo.indexOf(':') + 1]) {
                return resStyleClass + ' r-border'
            }
            return resStyleClass;
        },
        changeSourceFile() {
            this.axios.post('doctu/changeSourceFile/' + this.priceListFileId, this.file.formData).then((response) => {
                this.clearFileData();
                this.refreshLeftTable();
                this.$bus.fire('pricelist_file_changed');
            }, () => {

            });
        },
        fireConfirmEvent() {
            this.$emit('nextStep');
        },
        rowErrorTooltip(key){
            let res = '';
            if (this.info.errors[key] !== undefined){
                this.info.errors[key].forEach((item) => {
                    res = res + item.title+`<br/>`
                })
            }
            if (this.info.warnings[key] !== undefined){
                this.info.warnings[key].forEach((item) => {
                    res = res + item.title+`<br/>`
                })
            }
            return res;
        },
        getPricelessCatRow(row){
            let catClass = '';
            if (this.params.categoryType === 'priceless'){
                Object.keys(this.params.aliases).forEach((column) => {
                    if (this.params.aliases[column] === 'price' &&  (row[column] === undefined || row[column]['data'] === null || row[column]['data'] === '')){
                        catClass = 'table_left__td_cat';
                    }
                });
            }

            return catClass;
        },
        getRowErrorClass(key){
            if (this.info.errors[key] !== undefined){
                return 'tr__error';
            }
            if (this.info.warnings[key] !== undefined){
                return 'tr__warning';
            }
            return '';
        },
        infoTooltip(items) {
            let res = ''
            Object.keys(items).forEach((item) => {
                res = res+item+': '+ items[item]+`<br/>`
            })
            return res;
        },
    },
    computed: {
        paginationNumbers: function () {
            let page;
            let result = [];
            if (this.totalPages === 1) {
                return [{text: 1, value: 1}];
            } else if (this.totalPages <= this.pagesmax) {
                for (page = 1; page <= this.totalPages; page++) {
                    result.push({text: page, value: page});
                }
                return result;

            } else {

                let magicPagesmaxHalf = Math.ceil(this.pagesmax / 2);
                let pageOnStartOfButtons = this.currentPage <= magicPagesmaxHalf;
                let pageOnEndOfButtons = this.currentPage > (this.totalPages - magicPagesmaxHalf);
                if (pageOnStartOfButtons) {
                    let maxPagesToShow = Math.min(this.pagesmax, this.totalPages);
                    for (page = 1; page <= maxPagesToShow; page++) {
                        result.push({text: page, value: page});
                    }
                } else if (pageOnEndOfButtons) {
                    let minPageTillEnd = Math.min(this.currentPage - magicPagesmaxHalf, this.totalPages - this.pagesmax) + 1;
                    for (page = minPageTillEnd; page <= this.totalPages; page++) {
                        result.push({text: page, value: page});
                    }
                } else {
                    for (page = Math.max(this.currentPage - magicPagesmaxHalf + 1, 1); page < Math.min(this.currentPage + magicPagesmaxHalf, this.totalPages); page++) {
                        result.push({text: page, value: page});
                    }
                }
                if (result[0].text !== 1) {
                    let optionsBefore = [];
                    for (let i = 2; i < result[2].text && i < 100; i++) {
                        optionsBefore.push({text: i, value: i});
                    }

                    result[0] = {text: 1, value: 1};
                    result[1] = {text: '...', value: optionsBefore};
                }

                if (result[result.length - 1].text !== this.totalPages) {
                    let optionsAfter = [];
                    for (let j = result[result.length - 3].text + 1; j < this.totalPages && j < 100; j++) {
                        optionsAfter.push({text: j, value: j});
                    }

                    result[result.length - 2] = {text: '...', value: optionsAfter};
                    result[result.length - 1] = {text: this.totalPages, value: this.totalPages};
                }
                return result;
            }
        },
        totalPages (){
           return Math.ceil(Object.keys(this.leftTableData.rows).length/200)
        },
        paginatedRows (){
            return _.pick(this.leftTableData.rows,Object.keys(this.leftTableData.rows).slice(this.currentPage*200 - 200,this.currentPage*200))
        },
        pagesList () {
            let res = [];
            for (let i = 1; i <= this.totalPages; i++) {
                res.push({value: i, text: 'Стр: '+i})
            }
            return res;
        },
        ...mapState({
            priceListFileId: state => state.stepTwo.priceListFileId,
            params: state => state.stepTwo.params,
            info: state => state.stepTwo.info,
        }),
        warningsSum () {
          return _.sum(Object.values(this.info.warnings_info))
        },
        errorsSum () {
            return _.sum(Object.values(this.info.errors_info))
        },
        computedHeadersList () {
            if (this.params.categoryType === 'column'){
                return this.headersList;
            }

            return this.headersList.filter(
                item => item.value !== 'category' && item.value !== 'subcategory1' && item.value !== 'subcategory2'
            );
        }
    },
    watch: {
        totalPages (newVal) {
            if (newVal < this.currentPage){
                this.currentPage = newVal;s
            }
        },
        aliases: {
            deep: true,
            immediate: false,
            handler: function(newVal) {
                this.setAliases(newVal)
            }
        },
        'params.categoryType' (newVal) {
            if (newVal !== 'column') {
                Object.keys(this.params.aliases).forEach((column) => {
                    if (
                        this.params.aliases[column] === 'category'
                        || this.params.aliases[column] === 'subcategory1'
                        || this.params.aliases[column] === 'subcategory2'
                    ) {
                        this.aliases[column] = null;
                    }
                });
            }
        },
        'file.formData' (newVal) {
            if (newVal !== ''){
                this.changeSourceFile();
            }
        },
        'params.parseFromRow' (newVal) {
            if (newVal==='' || newVal <=1){
                this.setShowFromRow(1);
            }else{
                this.setShowFromRow(newVal);
            }
        },
        'params.showFromRow' () {
                this.refreshLeftTable()
        },
        'params.showLimit' () {
                this.refreshLeftTable()
        }
    },
    beforeDestroy (){
        this.resetData();
    }
}
</script>
<style lang="scss" scoped>

.left_block {
    width: 50%;
    height: 100%;
}
.div__table_left {
    height: 96%;
    overflow: scroll;
}
.left_block__fieldset{
    width: 100%;
}
.fieldset_params {
    overflow: initial;
    height:15%;
}
.fieldset_orig_table {
    height:84%;
}
.params {
    height: 53px;
}
.params__element {
    text-align: -webkit-center;
    display: inline-block;
}

.table_left {
    font-size: 0.8em;
    margin-left: 3px;
    margin-top: 5px;
    min-width: 99%;
}
.table_left td {
    border: 1px solid #e6e4e4;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 150px;
    min-width: 50px;
}

.table_left th {
    max-width: 50px;
    border: 1px solid #e6e4e4;
}
.table_left__cell_default{
    padding: 1px 4px 2px 6px;
    cursor: pointer;
    text-overflow: ellipsis;
    overflow: hidden;
}
.table_left__td_cat {
    border: 2px dashed green !important;
}
.table_left__td_cat_merge {
    background: #b1b1b12e;
    font-weight: bold;
}
.lastRow {
    border-bottom: 4px solid black;
}
.table_left__tr_head_first{
    background: gainsboro;
}
.element_errors{
    text-align: left;
    margin-left: 30px;
}
.element_errors__critical {
    color: red;
    display: block;
}
.element_errors__warnings {
    color: #ffb700;
    display: block;
}
.element_errors .fas {
    margin-right: 5px;
}
.i_info_help {
    color: grey;
    cursor: pointer;
}
.tr__error {
    background: red !important;
}
.tr__error td {
    border-color: #e23d3d;
}
.tr__warning {
    background-color: #ffa81f !important;
}
.tr__warning td {
    border-color: #f19000;
}
.params__element label {
    width: 100%;
}
.params__element .fa-question-circle {
    cursor: pointer;
}
</style>
